import React from 'react'

import { Col, Row } from '_zari/core'

import * as Sections from './sections'

const EstadoFinancieroReportePage = () => {
  return (
    <>
      <Row>
        <Col md={6}>
          <Sections.EstadoFinancieroSection />
        </Col>
        <Col md={6}>
          <Sections.HistorialCuentaPendienteSection />
        </Col>
      </Row>
    </>
  )
}

export default EstadoFinancieroReportePage
